import { render, staticRenderFns } from "./LocalSponsor.vue?vue&type=template&id=7915ba3a&scoped=true&"
import script from "./LocalSponsor.vue?vue&type=script&lang=js&"
export * from "./LocalSponsor.vue?vue&type=script&lang=js&"
import style0 from "./LocalSponsor.vue?vue&type=style&index=0&id=7915ba3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7915ba3a",
  null
  
)

export default component.exports